export default __webpack_public_path__ + "6770c51fdd27408f1172fd57b5c2f439.png";